import { useFeature } from "../features";

export const useExternalAccountsOnDashboardEnabled = (): boolean => {
  const { featureEnabled } = useFeature();
  return featureEnabled("enable_external_accounts_on_dashboard");
};
